import { trackDatadogAction } from '@proposify/frontend-observability';

// Dimensioned by `code` so counts reconcile with backend's per-code metric.
export function trackVariableValidationError(code: string, variableName: string): void {
  trackDatadogAction({ action: 'Variable Validation Error Encountered', data: { code, variableName } });
}
